import type { MenstrualHealthState } from "./MenstrualHealthContext";

export type MenstrualHealthFlowRoute =
  | "CycleStatus"
  | "AgeAtFirstPeriod"
  | "CycleDetails"
  | "Last3Periods"
  | "BleedOutsidePeriod"
  | "PainScale"
  | "PainMedication"
  | "Symptoms"
  | "FertileWindow"
  | "MenstrualHealthComplete";

export function buildMenstrualHealthNavigationStack(
  state: MenstrualHealthState,
): MenstrualHealthFlowRoute[] {
  const stack: MenstrualHealthFlowRoute[] = ["CycleStatus"];

  const status = state.cycleStatus;

  if (status === "never_had_period") {
    // Minimal flow: CycleStatus → FertileWindow → Complete
    stack.push("FertileWindow");
    stack.push("MenstrualHealthComplete");
    return stack;
  }

  if (
    status === "no_longer_have_period" ||
    status === "no_period_due_to_contraception"
  ) {
    // Partial flow: skip CycleDetails and Last3Periods
    stack.push("AgeAtFirstPeriod");
    stack.push("BleedOutsidePeriod");
    stack.push("PainScale");
    stack.push("PainMedication");
    stack.push("Symptoms");
    stack.push("FertileWindow");
    stack.push("MenstrualHealthComplete");
    return stack;
  }

  // Full flow: regular_cycle or irregular_cycle (or null - default full flow).
  // Cycle length is derived from the period start dates, so there is no
  // separate manual min/max step in the active questionnaire.
  if (status === "regular_cycle" || status === "irregular_cycle" || !status) {
    if (status) {
      stack.push("AgeAtFirstPeriod");
      stack.push("Last3Periods");
      stack.push("BleedOutsidePeriod");
      stack.push("PainScale");
      stack.push("PainMedication");
      stack.push("Symptoms");
      stack.push("FertileWindow");
    }

    stack.push("MenstrualHealthComplete");
    return stack;
  }

  stack.push("MenstrualHealthComplete");
  return stack;
}
